import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import TimeSelection from "/components/estate-calendar/components/TimeSelection";
import AppointmentForm from "/components/estate-calendar/components/AppointmentForm";

export const TIME_SELECTION = "TIME_SELECTION";
export const APPOINTMENT_FORM = "FORM";

export default props => {
    const [showCalendar, setShowCalendar] = useState(false);
    const [currentDate, ] = useState(new Date());
    // We use the selected date as the start of a week that will be displayed.
    const [selectedDate, setSelectedDate] = useState(new Date(currentDate));
    const [selectedPane, setSelectedPane] = useState(TIME_SELECTION);
    const [availability, setAvailability] = useState(null);
    const [appointments, setAppointments] = useState([]);
    const [appointmentId, setAppointmentId] = useState(null);

    const toAppointment = appointment => {
        return {
            appointmentId: appointment.id,
            appointmentDate: new Date(appointment.startDateTime.substr(0, 10)),
            startTime: new Date(appointment.startDateTime),
            endTime: new Date(appointment.endDateTime)
        };
    };

    useEffect(() => {
       setAppointments(Object.values(props.appointments).map(appointment => toAppointment(appointment)));
    }, []);

    const getWeek = () => {
        // Place call here to get availabilities.
        const dayPlus1 = new Date(selectedDate);
        dayPlus1.setDate(dayPlus1.getDate() + 1);
        const dayPlus2 = new Date(selectedDate);
        dayPlus2.setDate(dayPlus2.getDate() + 2);
        const dayPlus3 = new Date(selectedDate);
        dayPlus3.setDate(dayPlus3.getDate() + 3);
        const dayPlus4 = new Date(selectedDate);
        dayPlus4.setDate(dayPlus4.getDate() + 4);
        const dayPlus5 = new Date(selectedDate);
        dayPlus5.setDate(dayPlus5.getDate() + 5);
        const dayPlus6 = new Date(selectedDate);
        dayPlus6.setDate(dayPlus6.getDate() + 6);

        return [
            selectedDate,
            dayPlus1,
            dayPlus2,
            dayPlus3,
            dayPlus4,
            dayPlus5,
            dayPlus6,
        ];
    };

    const canGoLower = () => currentDate.getTime() < selectedDate.getTime();

    const addWeek = () => {
        const date = new Date(selectedDate);
        date.setDate(selectedDate.getDate() + 7);
        return setSelectedDate(date);
    };

    const subtractWeek = () => {
        if (canGoLower) {
            const date = new Date(selectedDate);
            date.setDate(selectedDate.getDate() - 7);
            return setSelectedDate(date);
        }
    };

    const renderPane = () => {
        if (selectedPane === TIME_SELECTION) {
            return (
                <TimeSelection
                    appointments={ appointments }
                    week={ getWeek() }
                    addWeek={ addWeek }
                    subtractWeek={ subtractWeek }
                    selectedDate={ selectedDate }
                    currentDate={ currentDate }
                    canGoLower={ canGoLower() }
                    setSelectedPane={ setSelectedPane }
                    setAppointmentId={ setAppointmentId }
                />
            );
        } else {
            return (
                <AppointmentForm
                    setSelectedPane={ setSelectedPane }
                    appointmentId={ appointmentId }
                    appointmentDate={ appointments.find(appointment => appointment.appointmentId == appointmentId).appointmentDate }
                    startTime={ appointments.find(appointment => appointment.appointmentId == appointmentId).startTime }
                />
            );
        }
    };

    const estateCalendar = document.querySelector('[data-estate-calendar]');

    return (
        <>
            <button
                onClick={ () => setShowCalendar(true) }
                className="calendar-button button"
                style={{ marginTop: "1.5rem" }}
            >
                { window.makeAppointmentTranslation }
            </button>

            { showCalendar && ReactDOM.createPortal(
                (
                    <div className="calendar">
                        <div className="calendar__close" onClick={ () => setShowCalendar(false) } />
                        <div className="calendar__container">
                            { renderPane() }
                        </div>
                    </div>
                ),
                estateCalendar
            )}
        </>
    );
};
